module.exports = __webpack_public_path__ + "static/media/concessionariaDeAutomoveis.3798a532.svg";